export default "__VITE_ASSET__DRtNGlol__"